export type PaymentPlatform = "ARMY" | "NON_ARMY";

export type PaymentProgramCode =
  | "MCCYN"
  | "MCYPL"
  | "MCYEx"
  | "RSPT"
  | "NAFER"
  | "ERSPT";

export type PaymentTypeCode = "ATTD" | "RFEE";

export type PaymentTransactionStatus =
  | "AUTHORIZED"
  | "CALCULATED"
  | "ERROR"
  | "NOT_CALCULATED"
  | "PAID"
  | "PENDING"
  | "REJECTED"
  | "RETURNED"
  | "VOID";

export const PaymentProgramLabels: Record<PaymentProgramCode, string> = {
  MCCYN: "MCCYN",
  MCYPL: "MCCYN PLUS",
  MCYEx: "MCCYN w/ Exception",
  RSPT: "Army Respite",
  NAFER: "NAFER",
  ERSPT: "EFM Respite",
};

export const PaymentTypeLabels: Record<PaymentTypeCode, string> = {
  ATTD: "Attendance Sheet",
  RFEE: "Registration Fee",
};

export const PAYMENT_PROGRAM_CODES = Object.keys(
  PaymentProgramLabels,
) as PaymentProgramCode[];

export const PAYMENT_TYPE_CODES = Object.keys(
  PaymentTypeLabels,
) as PaymentTypeCode[];

/**
 * Batched payment row returned by the provider and family payments endpoints.
 * Both views share this shape.
 */
export interface IPayment {
  platform: PaymentPlatform;
  transactionDetailId: number;
  householdId: number;
  providerId: number;
  providerName: string;
  childId: number;
  childName: string;
  certificateId: number | null;
  periodStartDate: string | null;
  periodEndDate: string | null;
  program: PaymentProgramCode;
  programDescription: string;
  paymentTypeCode: PaymentTypeCode;
  paymentTypeDescription: string;
  /** Decimal string, 2dp (e.g. "1500.00"). Do not parse as a float. */
  releasedAmount: string;
  transactionNotes: string | null;
  paymentReleaseDate: string;
  transactionStatus: PaymentTransactionStatus | string;
}
